class FaqCategoriesController extends HTMLElement {
  constructor() {
    super();
    this.currentCategory = 'general';
  }

  connectedCallback() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.section = this.querySelector('.ecs-faq-categories__layout');
    if (!this.section) {
      return;
    }

    this.sidebar = this.section.querySelector('.ecs-faq-categories__sidebar');
    this.categoryElements = this.section.querySelectorAll('.ecs-faq-categories__category');
    this.questionItems = this.section.querySelectorAll('.ecs-faq-categories__question-item');

    // Initialize the three main functions
    this.createSidebar();
    this.initializeAccordion();

    // Set initial state - hide all categories first
    this.categoryElements.forEach((category) => {
      category.classList.remove('active');
      category.classList.add('hidden');
    });

    // Show the first category by default
    if (this.categoryElements.length > 0) {
      const firstCategory = this.categoryElements[0];
      const firstCategoryHandle = firstCategory.getAttribute('data-category');
      this.currentCategory = firstCategoryHandle;
      this.showCategory(firstCategoryHandle);
    }
  }

  // Function 1: Create Sidebar
  createSidebar() {
    if (!this.sidebar) {
      return;
    }

    const categoryDescriptions = this.section.querySelectorAll('.ecs-faq-categories__category-description');

    // Clear sidebar first
    this.sidebar.innerHTML = '';

    categoryDescriptions.forEach((description) => {
      const categoryElement = description.closest('.ecs-faq-categories__category');
      const categoryHandle = categoryElement ? categoryElement.getAttribute('data-category') : 'general';
      const categoryTitle = categoryElement ? categoryElement.getAttribute('data-category-title') : 'general';
      const titleText = description.textContent.trim();

      if (titleText) {
        // Create the title element for sidebar
        const titleElement = document.createElement('h2');
        titleElement.className = 'ecs-faq-categories__category-title ecs-faq-categories__filter-btn js-faq-categories-filter';
        titleElement.setAttribute('data-category', categoryHandle);
        titleElement.setAttribute('data-category-title', categoryTitle);

        // Create a wrapper for the text and arrow
        const titleContent = document.createElement('div');
        titleContent.className = 'ecs-faq-categories__title-content';

        // Add the text
        const textSpan = document.createElement('span');
        textSpan.textContent = titleText;
        titleContent.appendChild(textSpan);

        // Add the arrow SVG
        const arrowSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        arrowSvg.setAttribute('width', '11');
        arrowSvg.setAttribute('height', '19');
        arrowSvg.setAttribute('viewBox', '0 0 11 19');
        arrowSvg.setAttribute('fill', 'none');
        arrowSvg.classList.add('ecs-faq-categories__title-arrow');

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute(
          'd',
          'M1 1L8.76066 8.32951C9.19656 8.74119 9.41451 8.94704 9.49363 9.18786C9.56025 9.39062 9.56025 9.60938 9.49363 9.81214C9.41451 10.053 9.19656 10.2588 8.76066 10.6705L1 18'
        );
        path.setAttribute('stroke', '#002853');
        path.setAttribute('stroke-width', '2');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');

        arrowSvg.appendChild(path);
        titleContent.appendChild(arrowSvg);

        // Add the content wrapper to the title element
        titleElement.appendChild(titleContent);

        // Add to sidebar
        this.sidebar.appendChild(titleElement);

        // Hide the original description in content
        description.style.display = 'none';

        // Add click event to title
        titleElement.addEventListener('click', () => {
          this.showCategory(categoryHandle);
        });
      }
    });

    this.showCategoryEventListener();
  }

  showCategoryEventListener() {
    const titleElements = this.querySelectorAll('.js-faq-categories-filter');

    titleElements.forEach((titleElement) => {
      titleElement.addEventListener('click', () => {
        const categoryHandle = titleElement.dataset.category;
        const categoryTitleButton = titleElement.dataset.categoryTitleButton;
        if (categoryTitleButton) {
          this.showCategory(categoryHandle, categoryTitleButton);
        } else {
          this.showCategory(categoryHandle);
        }
      });
    });
  }

  // Function 2: Hide/Show Categories
  showCategory(categoryHandle, categoryTitleButton) {
    this.currentCategory = categoryHandle;
    this.currentCategoryTitle = categoryTitleButton;

    // Reset all questions to visible and closed
    this.questionItems.forEach((item) => {
      item.classList.remove('hidden');
      item.classList.remove('active');
      const answer = item.querySelector('.ecs-faq-categories__answer');
      if (answer) answer.classList.remove('open');
    });

    if (categoryTitleButton) {
      this.categoryElements.forEach((category) => {
        const categoryDataCategoryTitle = category.getAttribute('data-category-title');

        if (categoryDataCategoryTitle === categoryTitleButton) {
          category.classList.add('active');
          category.classList.remove('hidden');
        } else {
          category.classList.remove('active');
          category.classList.add('hidden');
        }
      });

      this.updateSideBarButton(categoryHandle, categoryTitleButton);
    } else {
      // Show/hide categories - only show the selected one
      this.categoryElements.forEach((category) => {
        const categoryDataCategory = category.getAttribute('data-category');

          if (categoryDataCategory === categoryHandle) {
            category.classList.add('active');
            category.classList.remove('hidden');
          } else {
            category.classList.remove('active');
            category.classList.add('hidden');
          }
      });

      this.updateSideBarButton(categoryHandle);
    }
  }

  updateSideBarButton(categoryHandle, categoryTitleButton) {
    // Update sidebar button states
    const sidebarBtns = this.sidebar.querySelectorAll('.ecs-faq-categories__filter-btn');
    sidebarBtns.forEach((btn) => {
      if (btn.getAttribute('data-category') === categoryHandle) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    if (categoryTitleButton) {
      const sideBarCategoryTitle = this.querySelector('.js-faq-categories-filter:not(.esc-button)[data-category-title="' + categoryTitleButton + '"]');
      if (sideBarCategoryTitle) {
        sideBarCategoryTitle.classList.add('active');
      }
    }
  }

  // Function 3: Accordion Open/Close
  initializeAccordion() {
    this.questionItems.forEach((item) => {
      const question = item.querySelector('.ecs-faq-categories__question');
      const answer = item.querySelector('.ecs-faq-categories__answer');

      if (!question || !answer) return;

      question.addEventListener('click', () => {
        this.toggleAccordionItem(item, answer);
      });
    });
  }

  toggleAccordionItem(item, answer) {
    const isActive = item.classList.contains('active');
    const currentCategory = item.closest('.ecs-faq-categories__category');

    // Close all items in the same category
    if (currentCategory) {
      const categoryItems = currentCategory.querySelectorAll('.ecs-faq-categories__question-item');
      categoryItems.forEach((categoryItem) => {
        categoryItem.classList.remove('active');
        const categoryAnswer = categoryItem.querySelector('.ecs-faq-categories__answer');
        if (categoryAnswer) categoryAnswer.classList.remove('open');
      });
    }

    // If the clicked item was not active, open it
    if (!isActive) {
      item.classList.add('active');
      answer.classList.add('open');
    }
  }
}

// Register the custom element
customElements.define('faq-categories-controller', FaqCategoriesController);
